import { isNewItem } from '../utils/ARSCatalogUtils';

// Dati per i filtri dell'ARSCatalog

// Generi
export const genders = [
    { value: 'men', label: 'Men' },
    { value: 'women', label: 'Women' },
    { value: 'unisex', label: 'Unisex' },
    { value: 'kids', label: 'Kids' }
];

// Tipi di modello
export const modelTypes = [
    { value: 'sunglasses', label: 'Sunglasses' },
    { value: 'optical', label: 'Optical' },
    { value: 'clip-on', label: 'Clip-on' },
    { value: 'shield', label: 'Shield' }
];

// Tipologie
export const typologies = [
    { value: 'aviator', label: 'Aviator' },
    { value: 'cat-eye', label: 'Cat-Eye' },
    { value: 'rectangular', label: 'Rectangular' },
    { value: 'round', label: 'Round' },
    { value: 'oval', label: 'Oval' },
    { value: 'square', label: 'Square' },
    { value: 'geometric', label: 'Geometric' },
    { value: 'wayfarer', label: 'Wayfarer' }
];

// Funzione per applicare i filtri post-query (client-side)
export const applyPostQueryFilters = (products, postQueryFilters) => {
    let currentProducts = [...products];
    let matchedVariants = {};

    if (!postQueryFilters || Object.keys(postQueryFilters).length === 0) {
        return { products, matchedVariants: {} };
    }

    // 1. Applica filtri standard (lines, genders, etc.) prima della ricerca
    currentProducts = currentProducts.filter(product => {
        if (postQueryFilters.brands && postQueryFilters.brands.length > 0) {
            if (!product.mainBrandRef || !postQueryFilters.brands.includes(product.mainBrandRef)) {
                return false;
            }
        }
        if (postQueryFilters.lines && postQueryFilters.lines.length > 0) {
            if (!product.list_line_tags || !product.list_line_tags.some(lineId => postQueryFilters.lines.includes(lineId))) {
                return false;
            }
        }

        // 🎯 CORREZIONE: Usa combinedListTags invece dei filtri individuali che vengono azzerati
        if (postQueryFilters.combinedListTags && postQueryFilters.combinedListTags.length > 0) {
            if (!product.list_tags || !product.list_tags.some(tagId => postQueryFilters.combinedListTags.includes(tagId))) {
                return false;
            }
        }

        if (postQueryFilters.sizes && postQueryFilters.sizes.length > 0) {
            if (!product.list_size_tags || !product.list_size_tags.some(sizeId => postQueryFilters.sizes.includes(sizeId))) {
                return false;
            }
        }
        if (postQueryFilters.frameColors && postQueryFilters.frameColors.length > 0) {
            if (!product.list_frame_color_tags || !product.list_frame_color_tags.some(colorId => postQueryFilters.frameColors.includes(colorId))) {
                return false;
            }
        }

        if (postQueryFilters.showNews) {
            const isProductNew = isNewItem(product);
            const hasNewVariants = product.variants_map?.some(variant => variant.publishedInARSLibrary && isNewItem(variant));
            if (!isProductNew && !hasNewVariants) {
                return false;
            }
        }
        return true;
    });

    // 2. Filtro di ricerca testuale (se presente) sui risultati pre-filtrati
    if (postQueryFilters.searchTerm) {
        const normalizedSearch = postQueryFilters.searchTerm;
        const searchResults = [];

        currentProducts.forEach(product => {
            let productMatches = false;
            let specificMatchedVariants = new Set();

            // Match su campi prodotto
            if (product.searchable_modelName.includes(normalizedSearch) ||
                product.searchable_sku.includes(normalizedSearch) ||
                product.searchable_ean.includes(normalizedSearch) ||
                product.searchable_upc.includes(normalizedSearch)) {
                productMatches = true;
                if (product.searchable_modelName.includes(normalizedSearch)) {
                    product.variants_map.forEach(v => specificMatchedVariants.add(v.id));
                }
            }

            // Match su varianti
            if (product.variants_map?.length > 0) {
                product.variants_map.forEach(variant => {
                    if ((variant.variantName || '').toUpperCase().includes(normalizedSearch) ||
                        (variant.skuCode || '').toUpperCase().includes(normalizedSearch) ||
                        (variant.eanCode || '').toUpperCase().includes(normalizedSearch) ||
                        (variant.upcCode || '').toUpperCase().includes(normalizedSearch)) {
                        productMatches = true;
                        specificMatchedVariants.add(variant.id);
                    }
                });
            }

            if (productMatches) {
                searchResults.push(product);
                if (specificMatchedVariants.size > 0) {
                    matchedVariants[product.id] = Array.from(specificMatchedVariants);
                }
            }
        });
        currentProducts = searchResults;
    }

    return { products: currentProducts, matchedVariants };
};

/**
 * 🎯 NUOVO: Filtra le varianti in base ai filtri size, frameColors e showNews attivi
 * @param {Array} variants - Array delle varianti da filtrare
 * @param {Object} activeFilters - Filtri attivi (sizes, frameColors, showNews)
 * @returns {Array} Array delle varianti filtrate
 */
export const applyVariantFilters = (variants, activeFilters) => {
    if (!variants || variants.length === 0) {
        return variants;
    }

    if (!activeFilters || (!activeFilters.sizes?.length && !activeFilters.frameColors?.length && !activeFilters.showNews)) {
        return variants;
    }

    return variants.filter(variant => {
        // Filtro per size - controlla list_size_color_tags delle varianti
        if (activeFilters.sizes && activeFilters.sizes.length > 0) {
            if (!variant.list_size_color_tags || !Array.isArray(variant.list_size_color_tags)) {
                return false;
            }

            // Verifica se almeno una size selezionata è presente nei tag della variante
            const hasMatchingSize = activeFilters.sizes.some(sizeId =>
                variant.list_size_color_tags.includes(sizeId)
            );

            if (!hasMatchingSize) {
                return false;
            }
        }

        // Filtro per frameColor - controlla list_size_color_tags delle varianti
        if (activeFilters.frameColors && activeFilters.frameColors.length > 0) {
            if (!variant.list_size_color_tags || !Array.isArray(variant.list_size_color_tags)) {
                return false;
            }

            // Verifica se almeno un frame color selezionato è presente nei tag della variante
            const hasMatchingFrameColor = activeFilters.frameColors.some(frameColorId =>
                variant.list_size_color_tags.includes(frameColorId)
            );

            if (!hasMatchingFrameColor) {
                return false;
            }
        }

        // 🎯 NUOVO: Filtro per "Show news" - usa ESATTAMENTE la stessa logica del badge NEW
        if (activeFilters.showNews) {
            // Usa direttamente isNewItem per garantire logica identica al badge
            if (!isNewItem(variant)) {
                return false;
            }
        }

        return true;
    });
};

// Funzione per applicare i filtri ai prodotti (mantenuta per compatibilità)
export const applyFilters = (products, filters) => {
    if (!filters || Object.keys(filters).every(key => !filters[key] || filters[key].length === 0)) {
        return products;
    }

    // Contatori per debug
    const filterCounters = {
        brandRejected: 0,
        genderRejected: 0,
        modelTypeRejected: 0,
        lineRejected: 0,
        accepted: 0
    };

    // Pre-elaborazione degli ID dei model types per evitare parsing ripetuto
    const parsedModelTypes = [];
    if (filters.modelTypes && filters.modelTypes.length > 0) {
        filters.modelTypes.forEach(modelTypeJson => {
            try {
                const modelTypeIds = JSON.parse(modelTypeJson);
                if (Array.isArray(modelTypeIds)) {
                    parsedModelTypes.push(modelTypeIds);
                } else {
                    console.error("modelTypeIds is not an array:", modelTypeIds);
                }
            } catch (e) {
                console.error("Error pre-parsing modelTypes filter:", e, "modelTypeJson:", modelTypeJson);
            }
        });
    }

    const filtered = products.filter(product => {
        // Filtro per brand
        if (filters.brands && filters.brands.length > 0) {
            if (!product.mainBrandRef || !filters.brands.includes(product.mainBrandRef)) {
                filterCounters.brandRejected++;
                return false;
            }
        }

        // Filtro per gender - Utilizza list_tags dal prodotto
        if (filters.genders && filters.genders.length > 0) {
            if (!product.list_tags || !Array.isArray(product.list_tags)) {
                filterCounters.genderRejected++;
                return false;
            }
            // Verifica se almeno uno degli ID di gender selezionati è presente in list_tags
            const hasSelectedGender = filters.genders.some(genderId =>
                product.list_tags.includes(genderId)
            );
            if (!hasSelectedGender) {
                filterCounters.genderRejected++;
                return false;
            }
        }

        // Filtro per model type - Utilizza list_tags dal prodotto
        if (parsedModelTypes.length > 0) {
            if (!product.list_tags || !Array.isArray(product.list_tags)) {
                filterCounters.modelTypeRejected++;
                return false;
            }

            // Verifica se almeno uno dei gruppi di model type contiene un tag del prodotto
            const hasMatchingModelType = parsedModelTypes.some(modelTypeIds =>
                modelTypeIds.some(tagId => product.list_tags.includes(tagId))
            );

            if (!hasMatchingModelType) {
                filterCounters.modelTypeRejected++;
                return false;
            }
        }

        // Filtro per line - Utilizza list_line_tags dal prodotto
        if (filters.lines && filters.lines.length > 0) {
            if (!product.list_line_tags || !Array.isArray(product.list_line_tags)) {
                filterCounters.lineRejected++;
                return false;
            }
            // Verifica se almeno uno degli ID delle linee selezionate è presente in list_line_tags
            const hasSelectedLine = filters.lines.some(lineId =>
                product.list_line_tags.includes(lineId)
            );
            if (!hasSelectedLine) {
                filterCounters.lineRejected++;
                return false;
            }
        }

        // 🎯 NUOVO: Filtro per size - Utilizza list_size_tags dal prodotto
        if (filters.sizes && filters.sizes.length > 0) {
            if (!product.list_size_tags || !Array.isArray(product.list_size_tags)) {
                filterCounters.sizeRejected = (filterCounters.sizeRejected || 0) + 1;
                return false;
            }
            // Verifica se almeno uno degli ID delle size selezionate è presente in list_size_tags
            const hasSelectedSize = filters.sizes.some(sizeId =>
                product.list_size_tags.includes(sizeId)
            );
            if (!hasSelectedSize) {
                filterCounters.sizeRejected = (filterCounters.sizeRejected || 0) + 1;
                return false;
            }
        }

        // 🎯 NUOVO: Filtro per frame color - Utilizza list_frame_color_tags dal prodotto
        if (filters.frameColors && filters.frameColors.length > 0) {
            if (!product.list_frame_color_tags || !Array.isArray(product.list_frame_color_tags)) {
                filterCounters.frameColorRejected = (filterCounters.frameColorRejected || 0) + 1;
                return false;
            }
            // Verifica se almeno uno degli ID dei frame color selezionati è presente in list_frame_color_tags
            const hasSelectedFrameColor = filters.frameColors.some(frameColorId =>
                product.list_frame_color_tags.includes(frameColorId)
            );
            if (!hasSelectedFrameColor) {
                filterCounters.frameColorRejected = (filterCounters.frameColorRejected || 0) + 1;
                return false;
            }
        }

        // 🎯 NUOVO: Filtro per frame shape - Utilizza list_tags dal prodotto (group "Forma")
        if (filters.frameShapes && filters.frameShapes.length > 0) {
            if (!product.list_tags || !Array.isArray(product.list_tags)) {
                filterCounters.frameShapeRejected = (filterCounters.frameShapeRejected || 0) + 1;
                return false;
            }
            // Verifica se almeno uno degli ID dei frame shape selezionati è presente in list_tags
            const hasSelectedFrameShape = filters.frameShapes.some(frameShapeId =>
                product.list_tags.includes(frameShapeId)
            );
            if (!hasSelectedFrameShape) {
                filterCounters.frameShapeRejected = (filterCounters.frameShapeRejected || 0) + 1;
                return false;
            }
        }

        // 🎯 NOTA: showNews è gestito in applyPostQueryFilters per caricare più prodotti

        filterCounters.accepted++;
        return true;
    });

    return filtered;
}; 